import { Ability } from 'ember-can';

export default class ExternalMediaEmbedAbility extends Ability {
  // Getter and setter
  get canRead() {
    return true;
  }

  get canUpdate() {
    return true;
  }
}
